"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.login2FA = exports.logout = exports.login = exports.ApiMissingCredentialsError = exports.ApiStatusError = exports.ApiResultError = exports.ApiJsonError = exports.ApiError = exports.origin = void 0;
exports.extractJsonOrThrow = extractJsonOrThrow;
var fetch_1 = require("./fetch");
var i18n_1 = __importDefault(require("../i18n"));
var sentry_1 = require("../sentry");
// eslint-disable-next-line no-restricted-globals
exports.origin = location.origin;
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiError;
}(Error));
exports.ApiError = ApiError;
var ApiJsonError = /** @class */ (function (_super) {
    __extends(ApiJsonError, _super);
    function ApiJsonError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiJsonError;
}(ApiError));
exports.ApiJsonError = ApiJsonError;
var ApiResultError = /** @class */ (function (_super) {
    __extends(ApiResultError, _super);
    function ApiResultError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiResultError;
}(ApiError));
exports.ApiResultError = ApiResultError;
var ApiStatusError = /** @class */ (function (_super) {
    __extends(ApiStatusError, _super);
    function ApiStatusError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiStatusError;
}(ApiError));
exports.ApiStatusError = ApiStatusError;
var ApiMissingCredentialsError = /** @class */ (function (_super) {
    __extends(ApiMissingCredentialsError, _super);
    function ApiMissingCredentialsError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiMissingCredentialsError;
}(ApiError));
exports.ApiMissingCredentialsError = ApiMissingCredentialsError;
function extractJsonOrThrow(response_1, errorMessage_1) {
    return __awaiter(this, arguments, void 0, function (response, errorMessage, autoLogoutMode) {
        var result, e_1;
        if (autoLogoutMode === void 0) { autoLogoutMode = "confirm"; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, response.json()];
                case 1:
                    result = (_a.sent());
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    throw new ApiJsonError("".concat(errorMessage, "\n").concat(e_1));
                case 3:
                    if (!(result.code === 100401)) return [3 /*break*/, 5];
                    return [4 /*yield*/, (0, exports.logout)()];
                case 4:
                    _a.sent();
                    // eslint-disable-next-line no-restricted-globals
                    if (autoLogoutMode === "firstLogin" || (autoLogoutMode === "confirm" && confirm(i18n_1.default.missingCredentialsLogout))) {
                        // eslint-disable-next-line no-restricted-globals, no-self-assign
                        location.href = location.href;
                        // eslint-disable-next-line no-restricted-globals
                    }
                    else if (autoLogoutMode === "extension" && confirm(i18n_1.default.missingCredentialsLogoutWithExtension)) {
                        (0, sentry_1.captureException)(new ApiMissingCredentialsError("extension login failed\n".concat(errorMessage, "\n").concat(result.error)));
                        // eslint-disable-next-line no-restricted-globals
                        location.href = "https://vrchat.com/home";
                    }
                    throw new ApiMissingCredentialsError("".concat(errorMessage, "\n").concat(result.error));
                case 5:
                    if (result.error) {
                        throw new ApiResultError("".concat(errorMessage, "\n").concat(result.error));
                    }
                    if (!response.ok)
                        throw new ApiStatusError(errorMessage);
                    return [2 /*return*/, result];
            }
        });
    });
}
var login = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (_a) {
        var headers, body, url, response, result;
        var _b = _a === void 0 ? {} : _a, username = _b.username, password = _b.password, authCookie = _b.authCookie, remember = _b.remember, autoLogoutMode = _b.autoLogoutMode;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    headers = {};
                    if (username)
                        headers.username = encodeURIComponent(username);
                    if (password)
                        headers.password = encodeURIComponent(password);
                    if (authCookie)
                        headers.authcookie = encodeURIComponent(authCookie);
                    if (autoLogoutMode === "firstLogin")
                        headers.firstlogin = "true";
                    body = new URLSearchParams();
                    if (remember)
                        body.set("remember", "true");
                    url = new URL("".concat(exports.origin, "/api/vrcapi/login"));
                    // eslint-disable-next-line no-console
                    console.warn("authCookie=".concat(authCookie != null, " length=").concat(authCookie === null || authCookie === void 0 ? void 0 : authCookie.length));
                    return [4 /*yield*/, (0, fetch_1.post)(url.href, { body: body, headers: headers })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, extractJsonOrThrow(response, "login error", autoLogoutMode)];
                case 2:
                    result = (_c.sent());
                    return [2 /*return*/, result];
            }
        });
    });
};
exports.login = login;
var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = new URL("".concat(exports.origin, "/api/vrcapi/logout"));
                return [4 /*yield*/, (0, fetch_1.post)(url.href)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, extractJsonOrThrow(response, "logout error")];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.logout = logout;
var login2FA = function (code) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = new URL("".concat(exports.origin, "/api/vrcapi/auth/twofactorauth/totp/verify"));
                return [4 /*yield*/, (0, fetch_1.post)(url.href, { body: new URLSearchParams({ code: code }) })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, extractJsonOrThrow(response, "2FA error")];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.login2FA = login2FA;
